<div class="EditContainer">
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="bezeichnung" [(ngModel)]="Report.bezeichnung">
        <label for="bezeichnung">Bezeichnung</label>
      </div>
    </div>
  </div>
  @if(!IsNew())
  {
  <div class="row mb-3">
    <div class="col">
      <DataGridView DataUrl="/Backend/Api/V2/ReportAdmin/{{Report.key}}/Routes" #Grid  [UseUrlFilter]="false"  KeyProperty="key">
        <DataGridViewColumn field="urlExpression" header="Url" >
          <ng-template #cell let-row>
            <span>/Backend/Report/{{row.urlExpression}}</span>
          </ng-template>
        </DataGridViewColumn>
        <DataGridViewColumn field="method" header="Method" />
        <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
          <ng-template #cell let-row>
            <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Report">
              <ng-template #staticContent>
                <app-route-edit [ReportID]="Report.key" [Route]="row" ></app-route-edit>
              </ng-template>
            </PopUpView>
          </ng-template>
          <ng-template #header >
            <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Report">
              <ng-template #staticContent>
                <app-route-edit [ReportID]="Report.key" ></app-route-edit>
              </ng-template>
            </PopUpView>
          </ng-template>
        </DataGridViewColumn>
      </DataGridView>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <report-designer [Report]="Report" #Editor></report-designer>
    </div>
  </div>
  }
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
